const BX = window.BX;

BX.Vue.create({
  name: 'ArmUsedMoreCarsList',
  el: '#usedcars-morecar',
  data() {
    return {}
  },
  mounted() {
    this.initSwiperMorecar();
    this.initSwiperMorecarItemImg();
  },
  methods: {
    initSwiperMorecar() {
      const swiperMorecarProps = {
        slidesPerView: 4,
        spaceBetween: 35,
        slideShadows: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          319: {
            slidesPerView: 1,
            spaceBetween: 50
          },
          769: {
            slidesPerView: 2,
            spaceBetween: 40
          },
          1199: {
            slidesPerView: 3,
          },
          1399: {
            slidesPerView: 4,
          }
        }
      };

      new Swiper(this.$el.querySelector('.swiper-morecar'), swiperMorecarProps);
    },
    initSwiperMorecarItemImg() {
      const swiperProps = {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        speed: 600,
        effect: 'fade',
      };

      const swiperElements = this.$el.querySelectorAll('.swiper-morecar-item-img');
      swiperElements.forEach((el) => {
        let slider = new Swiper(el, swiperProps);

        const paginationBullet = el.querySelectorAll('.pagination-division .swiper-pagination-bullet');
        paginationBullet.forEach(element => {
          element.addEventListener('mouseover', (event) => {
            let parent = event.target.parentNode;
            let index = Array.prototype.indexOf.call(parent.children, event.target);
            slider.slideTo(index);
          });

          element.addEventListener('click', (event) => {
            event.preventDefault();
            window.location.href = el.getAttribute('data-href');
          });
        });
      });
    }
  }
});